
app.singlepostController = app.singlepostController || {};
app.singlepostController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.sliders();
    },

    sliders : function () {
        $('.wp-block-gallery').slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            arrows: false,
        });

        $('.wp-block-gallery').append('<div class="arrow-prev"></div>');
        $('.wp-block-gallery').append('<div class="arrow-next"></div>');

        $('.wp-block-gallery .arrow-prev').on('click', function () {
            $(this).closest('.wp-block-gallery').slick('slickPrev');
        });

        $('.wp-block-gallery .arrow-next').on('click', function () {
            $(this).closest('.wp-block-gallery').slick('slickNext');
        });
    },
};

$(document).ready(function(){
    if($(".single-post, .page-default").length) {
        app.singlepostController.defaultAction.init();
    }
});
